import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchManageApiKeys, generateManageApiKey, revokeManageApiKey } from '../actions/apiKeys.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

/** Generate/revoke both refetch server-side (rows are enriched), so they set data+meta wholesale. */
const setList = (state: ListState, action: PayloadAction<any>) => {
  state.loading = false;
  state.data = action.payload.data;
  state.meta = action.payload.meta;
};

const manageApiKeysSlice = createSlice({
  name: 'manageApiKeys',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchManageApiKeys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManageApiKeys.fulfilled, setList)
      .addCase(fetchManageApiKeys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(generateManageApiKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateManageApiKey.fulfilled, setList)
      .addCase(generateManageApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(revokeManageApiKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(revokeManageApiKey.fulfilled, setList)
      .addCase(revokeManageApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default manageApiKeysSlice.reducer;
